import { useQuery, type UseQueryResult } from "@tanstack/react-query";
import { api } from "@/api/client";
import { queryKeys } from "@/api/queryKeys";
import type { DataResponse, NarezPlan } from "@/api/schemas";

/**
 * Nárezový plán dĺžkových materiálov varianty (tyče, pracovné dosky).
 *
 * Read-only — počíta sa na serveri pri každom GET, nikde sa neukladá a do
 * cien nevstupuje (dĺžkový materiál sa účtuje podľa čistej dĺžky dielca).
 * Preto tu nie je ani „spustiť"/„zrušiť" ako pri poreze tabúľ.
 */
export function useNarezPlan(
  variantaId: string | undefined,
): UseQueryResult<DataResponse<NarezPlan>> {
  return useQuery({
    queryKey: queryKeys.zakazky.narez(variantaId ?? ""),
    queryFn: async () => {
      const { data } = await api.get<DataResponse<NarezPlan>>(
        `/varianty/${variantaId}/narez`,
      );
      return data;
    },
    enabled: !!variantaId,
  });
}
